import resolveConfig from 'tailwindcss/resolveConfig';
import toPx from 'to-px';

import tailwindConfig from '../../../tailwind.config.js';
export { scrollTo } from './scroll.js';

const config = resolveConfig(tailwindConfig);

export const breakpoints = Object.keys(config.theme.screens).reduce(
    (breakpoints, breakpoint) => ({
        ...breakpoints,
        [breakpoint]: toPx(config.theme.screens[breakpoint]),
    }),
    {}
);

export const isScreenAtLeast = (size) => (
    $(window).outerWidth() >= breakpoints[size]
);
